import { render, staticRenderFns } from "./RequestACallCard.vue?vue&type=template&id=2b305500"
import script from "./RequestACallCard.vue?vue&type=script&lang=js"
export * from "./RequestACallCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports